export default {
    'reports': 'Reports',
    'double-visits': 'Double visits',
    'visits': 'Visits'
}